import { render, staticRenderFns } from "./UserWorkspaces.vue?vue&type=template&id=88915c48&"
import script from "./UserWorkspaces.vue?vue&type=script&lang=js&"
export * from "./UserWorkspaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports